import TicketLayout from './TicketLayout';

export default TicketLayout;
